export default "__VITE_ASSET__BAAtrUL8__"